module.exports = __webpack_public_path__ + "img/beeffcservice.08e20f0e.png";